import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import CustomDatePicker from '../Widgets/CustomDates/CustomDatePicker/CustomDatePicker';
import XtramModal, { XtramButton, XtramField, XtramInput, xtramStyles } from '../Widgets/XtramModal/XtramModal';

const AddExternalTransactionDialog = ({
    addBankTransactionDialog,
    handleCloseBankAddTransactionDialog,
    newBankEditableItem,
    changeNewBankTransaction,
    handleAddBankTransaction,
    selectedTBank,
}) => {
    const { t, i18n } = useTranslation();
    const direction = i18n.dir();

    useEffect(() => {
        if (!newBankEditableItem.transactionDate) {
            changeNewBankTransaction('transactionDate', dayjs());
        }
    }, [addBankTransactionDialog, newBankEditableItem]);

    const amountLabel = selectedTBank?.foreignCurrencyCode != null ? t('CurrencyAmount') : t('Amount');
    const canAdd = Boolean(
        newBankEditableItem.description
        && newBankEditableItem.reference
        && newBankEditableItem.transactionDate
        && newBankEditableItem.amount
    );

    return (
        <XtramModal
            open={addBankTransactionDialog}
            onClose={handleCloseBankAddTransactionDialog}
            title={t('AddBankCommand')}
            direction={direction}
            footer={
                <>
                    <XtramButton variant="secondary" onClick={handleCloseBankAddTransactionDialog}>{t('Cancel')}</XtramButton>
                    <XtramButton onClick={handleAddBankTransaction} disabled={!canAdd}>{t('Add')}</XtramButton>
                </>
            }
        >
            <div className={xtramStyles.formFields}>
                <XtramField label={t('Description')} required size="full">
                    <XtramInput
                        direction={direction}
                        placeholder={t('Description')}
                        value={newBankEditableItem.description || ''}
                        onChange={(e) => changeNewBankTransaction('description', e.target.value)}
                    />
                </XtramField>
                <XtramField label={t('Reference')} required>
                    <XtramInput
                        direction={direction}
                        placeholder={t('Reference')}
                        value={newBankEditableItem.reference || ''}
                        onChange={(e) => changeNewBankTransaction('reference', e.target.value)}
                    />
                </XtramField>
                <XtramField label={t('TransactionDate')} required>
                    <CustomDatePicker
                        date={newBankEditableItem.transactionDate || null}
                        onDateChange={(date) => {
                            if (date) changeNewBankTransaction('transactionDate', date);
                        }}
                        height="40px"
                    />
                </XtramField>
                <XtramField label={amountLabel} required>
                    <XtramInput
                        direction={direction}
                        type="number"
                        placeholder={amountLabel}
                        value={newBankEditableItem.amount || ''}
                        onChange={(e) => changeNewBankTransaction('amount', e.target.value)}
                    />
                </XtramField>
            </div>
        </XtramModal>
    );
};

export default AddExternalTransactionDialog;
